
















import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import MethodicalMaterialListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/MethodicalMaterialModels/MethodicalMaterialListResponse";
import { Route, RawLocation } from "vue-router";
@Component
export default class PageMethodicalMaterialsComponent extends Vue {
 materials: WsResponseModel<MethodicalMaterialListResponse> = null;
  mounted() {
    this.$meta.setTitle('Методическая копилка');
    this.getList();
  }
  getList() {
    this.$api.MethodicalMaterialsService.GetListEvent.once(
      this.onGetList.bind(this)
    );
    this.$api.MethodicalMaterialsService.GetList({});
  }
  onGetList(response: WsResponseModel<MethodicalMaterialListResponse>) {
    this.materials = response;
  }
}
